/* eslint-disable */
import { AuthenticatedTemplate } from '@azure/msal-react';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import SuspenseWrapper from '../../common/components/SuspenseWrapper';
import { AI_ADMIN_PATH } from '../../common/constants';
import { useTenant } from './components/tenantContext/TenantContext';

const Dashboard = lazy(() => import(/* webpackChunkName: "dshbd" */ './components/Dashboard'));
const ObserveContainer = lazy(() => import(/* webpackChunkName: "obsrv" */ './components/observe/ObserveContainer'));
const TelemetryContainer = lazy(() =>
  import(/* webpackChunkName: "tlmtry" */ './telemetry/components/TelemetryContainer')
);
const TrendsContainer = lazy(() => import(/* webpackChunkName: "trnds" */ './components/trends/TrendsContainer'));
const IngestionContainer = lazy(() =>
  import(/* webpackChunkName: "ingstn" */ './components/ingestion/IngestionContainer')
);
const TenantFeatureContainer = lazy(() =>
  import(/* webpackChunkName: "tn-cfg" */ './components/configuration/TenantFeatureContainer')
);
const TitleSearchContainer = lazy(() =>
  import(/* webpackChunkName: "tlt-srch" */ './components/titleSearch/TitleSearchContainer')
);
const ChatDataToc = lazy(() => import(/* webpackChunkName: "cht-toc" */ './components/titleSearch/ChatDataToc'));
const EffectivenessContainer = lazy(() =>
  import(/* webpackChunkName: "efctivns" */ './components/effectiveness/EffectivenessContainer')
);
const EvaluationContainer = lazy(() =>
  import(/* webpackChunkName: "eval-rpt" */ './components/evaluation/EvaluationContainer')
);
const AdminPromptComponent = lazy(() =>
  import(/* webpackChunkName: "admn-prmpt" */ './components/admin/AdminPromptComponent')
);
const UsersContainer = lazy(() => import(/* webpackChunkName: "usrs" */ './components/user/UsersContainer'));
const RolesContainer = lazy(() => import(/* webpackChunkName: "rls" */ './components/user/RolesContainer'));
const FeedbackContainer = lazy(() => import(/* webpackChunkName: "fedbk" */ './components/feedback/FeedbackContainer'));
const IdentifiersContainer = lazy(() =>
  import(/* webpackChunkName: "idntfrs" */ './components/Identifiers/IdentifiersContainer')
);

const Router = (props) => {
  const { tenant } = useTenant();
  const { tenantName } = tenant;
  return (
    <SuspenseWrapper>
      <Switch>
        <Route exact path={['/', '/dashboard']}>
          <AuthenticatedTemplate>
            <Redirect to={AI_ADMIN_PATH} />
          </AuthenticatedTemplate>
        </Route>

        <Route path={`/aiadmin/${tenantName}`} exact render={() => <Dashboard {...props} />} />

        <Route path={`/aiadmin/${tenantName}/observe/telemetry`} exact render={() => <TelemetryContainer />} />
        <Route path={'/aiadmin/:tenantname/observe/telemetry/:action'} render={() => <TelemetryContainer />} />
        <Route path={`/aiadmin/${tenantName}/observe`} exact render={() => <ObserveContainer />} />
        <Route path={'/aiadmin/:tenantname/observe/:action'} render={() => <ObserveContainer />} />
        <Route path={`/aiadmin/${tenantName}/feedback`} exact render={() => <FeedbackContainer />} />
        <Route path={'/aiadmin/:tenantname/feedback/:action'} render={() => <FeedbackContainer />} />
        <Route path={`/aiadmin/${tenantName}/trends`} exact render={() => <TrendsContainer />} />
        <Route path={'/aiadmin/:tenantname/trends/:action'} render={() => <TrendsContainer />} />
        <Route path={`/aiadmin/${tenantName}/ingestion`} exact render={() => <IngestionContainer />} />
        <Route path={`/aiadmin/${tenantName}/configuration`} exact render={() => <TenantFeatureContainer />} />
        <Route path={`/aiadmin/${tenantName}/titlesearch`} exact render={() => <TitleSearchContainer />} />
        <Route path={`/aiadmin/${tenantName}/effectiveness`} exact render={() => <EffectivenessContainer />} />
        <Route path={`/aiadmin/${tenantName}/evaluation`} exact render={() => <EvaluationContainer />} />
        <Route
          path={`/aiadmin/${tenantName}/promptmgt/effectiveness`}
          exact
          render={() => <EffectivenessContainer />}
        />
        <Route
          path={`/aiadmin/${tenantName}/reports`}
          exact
          render={() => <Redirect to={`/aiadmin/${tenantName}/evaluation`} />}
        />
        <Route
          path={`/aiadmin/${tenantName}/titlesearch/mcq/view/:bookId`}
          exact
          render={() => <ChatDataToc {...props} viewType="quiz" />}
        />
        <Route
          path={`/aiadmin/${tenantName}/titlesearch/aetquiz/view/:bookId`}
          exact
          render={() => <ChatDataToc {...props} viewType="aetquiz" />}
        />
        <Route
          path={`/aiadmin/${tenantName}/titlesearch/aettopic/view/:bookId`}
          exact
          render={() => <ChatDataToc {...props} viewType="aettopic" />}
        />
        <Route
          path={`/aiadmin/${tenantName}/titlesearch/summary/view/:bookId`}
          exact
          render={() => <ChatDataToc {...props} viewType="summary" />}
        />
        <Route path={`/aiadmin/${tenantName}/promptmgt`} exact render={() => <AdminPromptComponent />} />

        <Route path={`/aiadmin/${tenantName}/users`} exact render={() => <UsersContainer />} />
        <Route path={`/aiadmin/${tenantName}/roles`} exact render={() => <RolesContainer />} />
        <Route path={`/aiadmin/${tenantName}/identifiers`} exact render={() => <IdentifiersContainer />} />
        <Route render={() => <Redirect to={AI_ADMIN_PATH} />} />
      </Switch>
    </SuspenseWrapper>
  );
};

export default Router;
